import { createApp } from 'vue';
import WmaToWavConverter from '@/Components/WmaToWavConverter.vue';
import '@styles/app.css';

createApp(WmaToWavConverter).mount('#wma-to-wav-converter');
